import React from 'react'
import MaterialSymbol from '../material-symbol'

const RateReview = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="rate_review" {...props} />
))

RateReview.displayName = 'RateReview'

export default RateReview
